import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import churidarkids from "../images/churidar kids.jpg";
import shirt from "../images/Shirt kids.jpg";
import kidslehenga from "../images/Kids lehenga.jpg";
import Blazer from "../images/Blazer kids.jpg";



function Menswear() {
  return (
    <div>
      <Navbar />
      <br />
      <br />

<br/>
<br/>
      <div className='ranaghatsaree'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Kids Wear</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='#'>
                    <div className="card">
                      <img src={churidarkids} className="card-img-top" alt="churidarkids"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Churidar </h5>
                        <p className="card-text">Best churidar available</p>
                        <a href="#" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
      
                <div className="col-md-6 mt-3">
                  <a href='#'>
                    <div className="card" >

                      <img src={shirt} className="card-img-top" alt="kids shirt"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Shirt</h5>
                        <p className="card-text">Best T-Short products</p>
                        <a href="#" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

            </div>

<div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='#'>
                    <div className="card">
                      <img src={Blazer} className="card-img-top" alt="kidsBlazer"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Blazer</h5>
                        <p className="card-text">Best Blazer available</p>
                        <a href="#" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
      
                <div className="col-md-6 mt-3">
                  <a href='#'>
                    <div className="card" >

                      <img src={kidslehenga} className="card-img-top" alt="kidslehenga" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Lehenga</h5>
                        <p className="card-text">Best Jacket products</p>
                        <a href="#" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

            </div>



          </div>
        </div>
      </div>

      {/* <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='t-shirt'>
                    <div className="card">
                      <img src={punjabi} className="card-img-top" alt="men punjabi" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">T-Shirt</h5>
                        <p className="card-text">Best T-Shirt available</p>
                        <a href="t-shirt" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='top'>
                    <div className="card" >

                      <img src={Blazer} className="card-img-top" alt="Blazer"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Fancy crop top</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="top" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>





          </div>
        </div>
      </div> */}
      <br />
    </div>
  )
}

export default Menswear